import React, { useEffect, useRef } from 'react'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { useNavigate, useParams } from 'react-router-dom'
import { pickAdminStripe, resetAdminStripe, resetAdminStripeSearchUser, searchUser, selectAdminStripe, selectAdminStripes, selectSelectedUser, transferStripeSubscripitionAsync } from './AdminStripeSlice'
import { Button, FormControl, FormHelperText, TextField, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'

const AdminStripeEditor = () => {
  const { sid, operation } = useParams()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const adminStripes = useAppSelector(selectAdminStripes)
  const selectedAdminStripe = useAppSelector(selectAdminStripe)
  const selectedUser = useAppSelector(selectSelectedUser)

  const userNameIp = useRef<any>(null)
  const [userName, setUserName] = React.useState<any>('')

  useEffect(() => {
    const selectedAdminStripe = sid && adminStripes.content.find((u) => u.id === parseInt(sid))
    if (selectedAdminStripe) {
      dispatch(pickAdminStripe(selectedAdminStripe))
    }
  }, [sid, adminStripes])

  useEffect(() => {
    if (selectedAdminStripe && selectedAdminStripe.adminReviewed) {
      dispatch(resetAdminStripe())
      navigate({ 'pathname': `/admin/stripe` })
    }
  }, [dispatch, navigate, selectedAdminStripe])

  return (<div>{selectedAdminStripe && <>
    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
      Stripe {operation === 'transfer' ? 'Transfer' : 'Editor'}
    </Typography>
    {selectedUser?.id ? <>
      <Typography variant="h6" component="div" sx={{ flexGrow: 1, mt: 4 }}>{selectedUser?.userEmail}</Typography>
      <Typography variant="caption" component="div" sx={{ flexGrow: 1, color: grey[500], mb: 4 }}>{selectedUser?.userId}</Typography>
      <Button variant="contained" sx={{ marginRight: 2 }} onClick={() => {
        dispatch(transferStripeSubscripitionAsync({ transferReq: { subscriptionId: selectedAdminStripe.id, targetUserId: selectedUser.id } }))
      }}>Save</Button>
      <Button variant="outlined" sx={{ marginRight: 2 }} onClick={() => {
        dispatch(resetAdminStripeSearchUser())
      }}>Reset</Button>
    </> : <>
      <FormControl fullWidth={true} required={true} sx={{ marginBottom: 2 }}>
        <TextField id="ip-text-owner-id" label="Email of target user" variant="outlined" disabled={operation !== 'transfer'}
          name="org-name" type="text" ref={userNameIp} value={userName ?? ''}
          onChange={(e: any) => setUserName(e.target.value)} />
        <FormHelperText id="helper-text-owner-id">Email of the user to whom this subscription <em>{selectedAdminStripe.stripeEmail}</em> should be transfered to</FormHelperText>
      </FormControl>
      <Button variant="contained" sx={{ marginRight: 2 }} disabled={userName?.length <= 0} onClick={() => {
        dispatch(searchUser({ query: userName }))
      }}>Find</Button>
    </>}

    <Button variant="outlined" sx={{ marginRight: 2 }} onClick={() => {
      dispatch(resetAdminStripe())
      navigate({ 'pathname': `/admin/stripe` })
    }}>Cancel</Button>
  </>}
  </div>)
}

export default AdminStripeEditor